export const SETTING_SEASON_YEAR = "season_year";
const d = new Date();
let year = d.getFullYear();
export const SEASON_YEAR_DEFAULT = year;